import classNames from 'classnames';
import { Icons as Icon } from '../../Icons/Icons';
import { Button, Wrapper } from 'components';
import { handleViewForm } from 'utils';
import { ApprovalAction } from 'types';
import { ConfirmationWithReasonModal } from 'components-antd';

import { Table, Avatar } from 'components-antd';

import styles from './styles.module.scss';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Task } from 'pages/Workshop/Transactions/TransactionTasks/components';
import {
  getSymphonyOpenOffers,
  getSymphonyPendingShowings,
  getSymphonyPendingSignatures,
  getSymphonyPendingTourRequests,
} from 'api/symphony';
import { link } from 'settings/navigation/link';
import { AppointmentDetailsModal } from 'pages/Workshop/Showings/components/AppointmentDetailsModal';
import { FormDetails } from 'pages/Workshop/Forms/components/FormDetails';
import { onHandleViewFormType } from 'pages/Workshop/Forms';
import { resetTransactionEffect } from 'store/effects';
import { useManageShowingsList } from 'pages/Workshop/Showings/components/ShowingTabs/useManageShowingsList';

export const OffersModal = ({ row, variant = 'pendingTourRequests' }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const isOffers = variant === 'openOffers' || variant === 'expiringOffers';
  const [selectedFormProcess, setSelectedFormProcess] = useState(null);
  const [selectedFormStatus, setSelectedFormStatus] = useState('');
  const [data, setData] = useState([]);
  const [isPending, setIsPending] = useState(true);

  const fetchClientsData = async () => {
    const variantApiMap = {
      pendingTourRequests: getSymphonyPendingTourRequests,
      expiringOffers: getSymphonyOpenOffers,
      openOffers: getSymphonyOpenOffers,
      pendingShowingRequests: getSymphonyPendingShowings,
      pendingSignatures: getSymphonyPendingSignatures,
    };
    const selectedApi = variantApiMap[variant];
    try {
      const { data } = await selectedApi({
        agentId: row?.Id,
        ...(isOffers ? { isExpiring: variant === 'expiringOffers' } : {}),
      });
      if (data?.length) {
        setData(data);
      }
    } finally {
      setIsPending(false);
    }
  };

  const {
    data: column,
    setData: seColumn,
    showModal,
    isFeedback,
    processData,
    actionConfig,
    processAction,
    onDetailsClose,
    onReasonConfirm,
    pendingApprovers,
    appointmentModal,
    isApprovalRequired,
    redirectToOverview,
    onConfirmationCancel,
  } = useManageShowingsList({
    fetchShowingAggregate: () => {
      onDetailsClose();
      fetchClientsData();
    },
    activeTab: 1,
  });

  useEffect(() => {
    fetchClientsData();
  }, []);

  function getTimeSummary(duration) {
    const units = [
      { key: 'months', label: 'month' },
      { key: 'days', label: 'day' },
      { key: 'hours', label: 'hour' },
      { key: 'minutes', label: 'minute' },
      { key: 'seconds', label: 'second' },
    ];

    for (const { key, label } of units) {
      const value = duration[key];
      if (value && value > 0) {
        return `${value} ${label}${value > 1 ? 's' : ''}`;
      }
    }

    return '0 seconds';
  }

  function getRelativeDuration(futureDate) {
    const now = moment();
    const then = moment(futureDate);

    const duration = moment.duration(then.diff(now));

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    const parts: any = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);

    return `In ${parts.join(', ')}`;
  }

  const redirectToOffers = (data) => {
    return history.push({
      pathname: link.toTransactionOffers(data?.TransactionId),
      state: {
        offerIterationUUID: data?.UUID,
        triggerOfferDetail: true,
      },
    });
  };

  const redirectToTours = () => {
    history.push('/properties/tours');
  };

  const openFormDetailModal = (form) => {
    setSelectedFormProcess(form.FormProcessId);
    setSelectedFormStatus(form.Status || '');
  };

  const detailColumns: any = [
    ...(variant === 'pendingSignatures'
      ? [
          {
            title: 'Form',
            key: 'FormName',
            dataIndex: 'FormName',
            sorter: (a, b) => {
              let name = a?.FormName;
              let secondName = b?.FormName;
              return name.localeCompare(secondName);
            },
            render: (FormName) => {
              return (
                <div className={classNames(styles.val, styles.task)}>
                  <Icon className={styles.icon} variant={Icon.FORM} />
                  <p className={classNames(styles.p1, styles.noMargin)}>{FormName}</p>
                </div>
              );
            },
          },
          {
            title: 'Status',
            key: 'Status',
            dataIndex: 'Status',
            sorter: (a, b) => {
              let name = a?.Status;
              let secondName = b?.Status;
              return name.localeCompare(secondName);
            },
            render: (Status) => {
              const formattedStatuses = {
                WaitingOnYou: 'Waiting On You',
                WaitingOnOthers: 'Waiting On Others',
              };
              return (
                <div className={classNames(styles.val, styles.status)}>
                  <span className={classNames(styles.status, styles[Status])}>
                    {formattedStatuses?.[Status] || Status}
                  </span>
                </div>
              );
            },
          },
          {
            title: 'Transaction',
            key: 'Property',
            dataIndex: 'Property',
            sorter: (a, b) => {
              let name = a?.Property?.Address?.Line1 || '';
              let secondName = b?.Property?.Address?.Line1 || '';
              return name.localeCompare(secondName);
            },
            render: (Property) => {
              const Address = Property?.Address;
              return (
                <div className={classNames(styles.val, styles.task)}>
                  {Property ? (
                    <div>
                      <p className={styles.p1}>{Address?.Line1}</p>
                      <p
                        className={styles.p2}
                      >{`${Address?.City}, ${Address?.State} ${Address?.Zip}`}</p>
                    </div>
                  ) : (
                    '-'
                  )}
                </div>
              );
            },
          },
        ]
      : []),
    ...(isOffers
      ? [
          {
            title: 'Transaction',
            key: 'Property',
            dataIndex: 'Property',
            sorter: (a, b) => {
              let name = a?.Property?.Address?.Line1 || '';
              let secondName = b?.Property?.Address?.Line1 || '';
              return name.localeCompare(secondName);
            },
            render: ({ Address }) => {
              return (
                <div className={classNames(styles.val, styles.task)}>
                  <Icon className={styles.icon} variant={Icon.OFFER} />
                  <div>
                    <p className={styles.p1}>{Address?.Line1}</p>
                    <p
                      className={styles.p2}
                    >{`${Address?.City}, ${Address?.State} ${Address?.Zip}`}</p>
                  </div>
                </div>
              );
            },
          },
          {
            title: 'Client',
            key: 'Clients',
            dataIndex: 'Clients',
            sorter: (a, b) => {
              let name = a?.Clients?.[0] || '';
              let secondName = b?.Clients?.[0] || '';
              return name.localeCompare(secondName);
            },
            render: (Clients) => (
              <div className={classNames(styles.val, styles.client)}>
                {Clients?.[0] && (
                  <Avatar className={styles.avatar} size={24} src={''}>
                    {Clients?.[0]
                      .split(' ')
                      .map((name) => name.charAt(0).toUpperCase())
                      .join('')}
                  </Avatar>
                )}
                <p className={styles.name}>{Clients?.[0] || '-'}</p>
              </div>
            ),
          },
          {
            title: 'Status',
            key: 'Status',
            dataIndex: 'Status',
            sorter: (a, b) => {
              let name = a?.Status;
              let secondName = b?.Status;
              return name.localeCompare(secondName);
            },
            render: (Status) => {
              return (
                <div className={classNames(styles.val, styles.status)}>
                  <span className={classNames(styles.status, styles[Status])}>{Status}</span>
                </div>
              );
            },
          },
          {
            title: 'Expires',
            key: 'EndDate',
            dataIndex: 'EndDate',
            sorter: (a, b) => moment(a.EndDate).unix() - moment(b.EndDate).unix(),
            render: (EndDate) => (
              <p className={classNames(styles.val, styles.dueDate)}>
                {EndDate ? getRelativeDuration(EndDate) : '-'}
              </p>
            ),
          },
        ]
      : []),
    ...(variant === 'pendingTourRequests'
      ? [
          {
            title: 'Listing',
            key: 'task',
            dataIndex: 'task',
            sorter: (a, b) => {
              let name = a?.PropertyAddress?.Line1;
              let secondName = b?.PropertyAddress?.Line1;
              return name.localeCompare(secondName);
            },
            render: (_, { PropertyAddress }) => {
              return (
                <div className={classNames(styles.val, styles.task)}>
                  <Icon className={styles.icon} variant={Icon.CALENDER} />
                  <div>
                    <p className={styles.p1}>{PropertyAddress?.Line1}</p>
                    <p className={styles.p2}>
                      {`${PropertyAddress.City}, ${PropertyAddress.State} ${PropertyAddress.Zip}`}
                    </p>
                  </div>
                </div>
              );
            },
          },
          {
            title: 'Requested By',
            key: 'RequestedBy',
            dataIndex: 'RequestedBy',
            sorter: (a, b) => {
              let name = a?.RequestedBy;
              let secondName = b?.RequestedBy;
              return name.localeCompare(secondName);
            },
            render: (RequestedBy) => (
              <div className={classNames(styles.val, styles.text, styles.requestedBy)}>
                {RequestedBy}
              </div>
            ),
          },
          {
            title: 'MLS #',
            key: 'PropertyId',
            dataIndex: 'PropertyId',
            sorter: (a, b) => {
              let name = a?.PropertyId;
              let secondName = b?.PropertyId;
              return name.localeCompare(secondName);
            },
            render: (PropertyId) => (
              <div className={classNames(styles.val, styles.text, styles.mls)}>{PropertyId}</div>
            ),
          },
          {
            title: 'Pending',
            key: 'PendingSince',
            dataIndex: 'PendingSince',
            sorter: (a, b) => {
              let name = getTimeSummary(a?.PendingSince) || '';
              let secondName = getTimeSummary(b?.PendingSince) || '';
              return name.localeCompare(secondName);
            },
            render: (PendingSince) => (
              <div className={classNames(styles.val, styles.text, styles.pendingSince)}>
                {getTimeSummary(PendingSince)}
              </div>
            ),
          },
        ]
      : []),
    ...(variant === 'pendingShowingRequests'
      ? [
          {
            title: 'Date & Time',
            key: 'AppointmentStartTime',
            dataIndex: 'AppointmentStartTime',
            sorter: (a, b) => {
              const dateA = new Date(a?.AppointmentStartTime).getTime();
              const dateB = new Date(b?.AppointmentStartTime).getTime();
              return dateA - dateB;
            },
            render: (AppointmentStartTime) => {
              return (
                <div className={classNames(styles.val, styles.task, styles.dateTime)}>
                  <Icon className={styles.icon} variant={Icon.CALENDER} />
                  <div>
                    <p className={styles.p1}>
                      {moment(AppointmentStartTime).local().format('M/D/YYYY')}
                    </p>
                    <p className={classNames(styles.p2, styles.appointmentStartTime)}>
                      {moment(AppointmentStartTime).local().format('h:mm A')}
                    </p>
                  </div>
                </div>
              );
            },
          },
          {
            title: 'Status',
            key: 'AppointmentStatus',
            dataIndex: 'AppointmentStatus',
            sorter: (a, b) => {
              let name = a?.AppointmentStatus;
              let secondName = b?.AppointmentStatus;
              return name.localeCompare(secondName);
            },
            render: (AppointmentStatus) => {
              return (
                <div className={classNames(styles.val, styles.statusShowing)}>
                  <span
                    className={classNames(
                      styles.status,
                      styles[AppointmentStatus + 'pendingShowing'],
                    )}
                  >
                    {AppointmentStatus}
                  </span>
                </div>
              );
            },
          },
          {
            title: 'Listing',
            key: 'Property',
            dataIndex: 'Property',
            sorter: (a, b) => {
              let name = a?.Property?.Address?.Line1 || '';
              let secondName = b?.Property?.Address?.Line1 || '';
              return name.localeCompare(secondName);
            },
            render: ({ Address }) => {
              return (
                <div className={classNames(styles.val, styles.task)}>
                  <Icon className={styles.icon} variant={Icon.LOCATION} />
                  <div>
                    <p className={styles.p1}>{Address?.Line1}</p>
                    <p
                      className={styles.p2}
                    >{`${Address?.City}, ${Address?.State} ${Address?.Zip}`}</p>
                  </div>
                </div>
              );
            },
          },
          {
            title: 'Requested By',
            key: 'BuyingAgentName',
            dataIndex: 'BuyingAgentName',
            sorter: (a, b) => {
              let name = a?.BuyingAgentName;
              let secondName = b?.BuyingAgentName;
              return name.localeCompare(secondName);
            },
            render: (_, { BuyingAgentName, BuyingAgentBrokerage }) => {
              return (
                <div className={classNames(styles.val, styles.task)}>
                  <div>
                    <p className={classNames(styles.p1, styles.buyingAgentName)}>
                      {BuyingAgentName}
                    </p>
                    <p className={styles.p2}>{`${BuyingAgentBrokerage} Brokerage`}</p>
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
    {
      title: '',
      key: 'view',
      dataIndex: 'view',
      render: (_, record) => {
        return (
          <div className={classNames(styles.val, styles.buttons)}>
            <Button
              isPending={false}
              className={styles.button}
              onClick={() => {
                switch (variant) {
                  case 'pendingTourRequests':
                    redirectToTours();
                    break;
                  case 'expiringOffers':
                    redirectToOffers(record);
                    break;
                  case 'openOffers':
                    dispatch(resetTransactionEffect());
                    redirectToOffers(record);
                    break;
                  case 'pendingShowingRequests':
                    redirectToOverview(record);
                    break;
                  case 'pendingSignatures':
                    openFormDetailModal(record);
                    break;

                  default:
                    break;
                }
              }}
              title={'View'}
              disabled={false}
            />
          </div>
        );
      },
    },
  ];

  const onCloseFormDetailModal = () => {
    setSelectedFormProcess(null);
  };

  const onHandleViewForm: onHandleViewFormType = (url, type) => {
    handleViewForm(history, url, type);
  };

  //   return isUserApproverForPendingApproval && checkApproverSequence(data);
  // };

  return (
    <Wrapper isPending={isPending}>
      <Task />
      <ConfirmationWithReasonModal
        open={showModal}
        confirmText={<span>Are you sure you want to {actionConfig?.action} this showing?</span>}
        placeholder={`Write a reason for ${
          actionConfig?.action === ApprovalAction.Decline ? 'declining' : 'cancelling'
        }...`}
        okText={actionConfig?.action === ApprovalAction.Cancel ? 'Confirm' : actionConfig?.action}
        showReason={!(actionConfig?.action === ApprovalAction.Approve)}
        onOk={onReasonConfirm}
        onCancel={onConfirmationCancel}
      />
      <AppointmentDetailsModal
        isOpen={appointmentModal}
        onClose={onDetailsClose}
        UUID={column?.UUID?.toString()}
        isApprovalRequired={isApprovalRequired}
        pendingApprovers={pendingApprovers}
        processAction={processAction}
        isFeedback={isFeedback}
        processData={processData}
      />
      {selectedFormProcess && (
        <FormDetails
          selectedFormProcess={selectedFormProcess}
          onClose={onCloseFormDetailModal}
          onHandleViewForm={onHandleViewForm}
          selectedFormStatus={selectedFormStatus}
          refetchForms={() => {}}
          onDeleteFormSuccess={() => {
            onCloseFormDetailModal();
          }}
        />
      )}
      <Table
        loading={false}
        className={styles.detailsTable}
        bordered
        columns={detailColumns}
        dataSource={data}
        pagination={false}
        showSorterTooltip={false}
      />
    </Wrapper>
  );
};
